import { RankingView } from "@/components/ranking-view";

export default function Ranking() {
  return (
    <div className="flex flex-col">
      <div className="px-4 pt-4 md:px-8 md:pt-6">
        <h1 className="t-h1">Classement national</h1>
      </div>
      <RankingView testID="agent-ranking-screen" />
    </div>
  );
}
